const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancoIcbc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    d: "M3.01,9.01c0-3.33,2.68-6.01,6.01-6.01s5.99,2.68,5.99,6.01-2.7,5.99-5.99,5.99-6.01-2.7-6.01-5.99ZM3.9,9.01c0,.68.12,1.33.39,1.96.27.6.63,1.18,1.11,1.64.48.48,1.04.87,1.67,1.11.6.27,1.28.39,1.96.39,2.78,0,5.05-2.27,5.05-5.09s-2.27-5.12-5.05-5.12c-.68,0-1.35.14-1.96.39-.63.27-1.18.63-1.67,1.11s-.85,1.04-1.11,1.67c-.27.6-.39,1.28-.39,1.96h0Z",
    style: {
      fill: "#b81e2d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer-2",
    "data-name": "Layer",
    d: "M5.82,12.2h2.92v-.85h-2.08v-1.01h1.86v-2.66h-1.86v-1.01h2.08v-.85h-2.92v2.75h1.86v.94h-1.86v2.68ZM12.2,9.49h-1.91v-.94h1.91v-2.75h-2.95v.85h2.1v1.01h-1.91v2.68h1.91v1.01h-2.1v.85h2.95v-2.7Z",
    style: {
      fill: "#b81e2d",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoIcbc);
export default __webpack_public_path__ + "static/media/banco-icbc.9aa38c8a45f70ef284743bc5a30c6150.svg";
export { ForwardRef as ReactComponent };